// externals
import * as React from 'react';

// libraries
import { LoadingButtonUI } from '@makemydeal/dr-activities-common';

export interface IDealSummaryFooterUIProps {
    offerHasBeenSent: boolean;
    onActionButtonClick: { () };
    onContinueLinkClick?: { () };
    processing?: boolean;
    options?: any;
    buttonText?: string;
}

class DealSummaryFooterUI extends React.Component<IDealSummaryFooterUIProps, {}> {
    renderContinueLink() {
        return (
            <div className="deal-summary-page__continue">
                <a
                    id="deal-summary-page-continue-link"
                    className="deal-summary-page__continue-link"
                    onClick={this.props.onContinueLinkClick}
                >
                    No thanks, continue to next step.
                </a>
            </div>
        );
    }

    render() {
        /**
         * US207936: temporary remove continue to next step after initial offer
         * submission
         *
         * Conditions to show "No thanks, continue to next step." link:
         *  - toggle showContinueToNextStepPostOffer is false
         *  - offer has not been sent
         */
        const showContinueLink = !!this.props.onContinueLinkClick;
        const buttonText = this.props.buttonText
            ? this.props.buttonText
            : this.props.offerHasBeenSent
              ? 'Submit Updates'
              : 'Submit';

        return (
            <div>
                <div>
                    <LoadingButtonUI
                        buttonText={buttonText}
                        disabled={this.props.processing || false}
                        isPending={this.props.processing || false}
                        id="deal_summary_page_send_button"
                        isSubmit={true}
                        additionalClassParams="btn-block"
                        onClick={this.props.onActionButtonClick}
                    />
                </div>
                {showContinueLink && !this.props.offerHasBeenSent ? this.renderContinueLink() : null}
            </div>
        );
    }
}

export default DealSummaryFooterUI;
